/**
 * The flyer typefaces, vendored as TTF so the browser preview and the
 * server-side render use byte-identical files. See README.md for provenance.
 */
export const FLYER_FONTS = [
  { id: 'inter', family: 'Inter', file: 'Inter.ttf', variable: true },
  { id: 'montserrat', family: 'Montserrat', file: 'Montserrat.ttf', variable: true },
  { id: 'oswald', family: 'Oswald', file: 'Oswald.ttf', variable: true },
  { id: 'playfair', family: 'Playfair Display', file: 'PlayfairDisplay.ttf', variable: true },
  { id: 'bebas', family: 'Bebas Neue', file: 'BebasNeue.ttf', variable: false },
] as const

export type FlyerFont = (typeof FLYER_FONTS)[number]

export type FlyerFontId = FlyerFont['id']

export function flyerFont(id: FlyerFontId): FlyerFont {
  const found = FLYER_FONTS.find((font) => font.id === id)
  if (!found) throw new Error(`Unknown flyer font: ${id}`)
  return found
}
